// App name: Custom Google Map App
// Description:

const CustomGoogleMapApp = (function ($) {

  // variables

  // init
  function init() {
		_initMap('gMap');
		_initMap('fMap');
  }

	function _initMap(id) {
		let _target = $(`#${id}`);

		// console.log(_target)
		// console.log(_target.length)
		if(typeof google === 'undefined') return;
		if (_target.length > 0) {
			var myLatLng = { lat: 47.52053322466175, lng: 8.590417269461298 };
			var mapOptions = {
					zoom: 17,
					center: myLatLng,
			};

			var map = new google.maps.Map(document.getElementById(id), mapOptions);

			new google.maps.Marker({
					position: myLatLng,
					map,
			});
		}
	}


  return {
      init: init,
  };
})(jQuery);

jQuery('document').ready(function () {
  CustomGoogleMapApp.init();
});
